import { Pipe, PipeTransform } from '@angular/core';
import { formatUsPhoneDisplay } from '../utilities/phone.utility';

@Pipe({
  name: 'usPhoneFormat',
  standalone: false,
})
export class UsPhoneFormatPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return formatUsPhoneDisplay(value);
  }
}
